async function getPriceSettings() {
  let dealerSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    taxesFeesEnabled = false,
    cashDealPrice,
    negotiation = false
  } = dealerSettings;
  return {
    enableTaxesAndFees: taxesFeesEnabled,
    cashDealPrice,
    enableNegotiation: negotiation
  };
}
export { getPriceSettings as default };
